// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import urlJoin from 'url-join';

export const environment = {
  production: false,

  frontendAppUrl:
    window.env.APP_FRONTEND_URL ||
    urlJoin(window.location.protocol + '//' + window.location.hostname + ':3000', '/app'),

  backendServiceUrl:
    window.env.APP_BACKEND_SERVICE_URL ||
    urlJoin(window.location.protocol + '//' + window.location.hostname + ':3000', '/api'),

  googleAuthUri: window.env.GOOGLE_AUTH_URI || '',
  googleClientId: window.env.GOOGLE_CLIENT_ID || '',
  googleOauthRedirectUrl: window.env.GOOGLE_OAUTH_REDIRECT_URL || '',
  googleAnalyticsId: window.env.GOOGLE_ANALYTICS_ID || '',

  uploadImageFreeBatch: Number(window.env.APP_UPLOAD_IMAGE_FREE_BATCH) || 10,
  uploadImagePaidBatch: Number(window.env.APP_UPLOAD_IMAGE_PAID_BATCH) || 5,
  uploadImageThrottleDelay: Number(window.env.APP_UPLOAD_IMAGE_THROTTLE_DELAY) || 210,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
